"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.processConsoleLogMessages = void 0;
const common_1 = require("../common");
const initializeSourceMap_1 = require("./initializeSourceMap");
exports.processConsoleLogMessages = async (options) => {
    if (process.env.NODE_ENV !== 'production' || process.env.NEO_ONE_DEV === 'true') {
        initializeSourceMap_1.initializeSourceMap();
        await common_1.processConsoleLogMessages(options);
    }
};

//# sourceMappingURL=processConsoleLogMessages.js.map
